document.addEventListener("DOMContentLoaded", function () {

  /* =========================================================
     ELEMENTS
  ========================================================= */

  const widthSelect = document.querySelector("#riviera-grid-width");
  const heightSelect = document.querySelector("#riviera-grid-height");
  const createButton = document.querySelector("#riviera-create-grid");
  const grid = document.querySelector("#riviera-grid");

  const dimensionsText = document.querySelector("#riviera-dimensions");
  const countText = document.querySelector("#riviera-count");
  const filledText = document.querySelector("#riviera-filled-count");
  const priceText = document.querySelector("#riviera-total-price");

  const productList = document.querySelector("#riviera-product-list");
  const productStatus = document.querySelector("#riviera-product-status");
  const searchInput = document.querySelector("#riviera-search");

  const clearCellButton = document.querySelector("#riviera-clear-cell");
  const clearAllButton = document.querySelector("#riviera-clear-all");

  const addCartButton = document.querySelector("#riviera-add-cart");
  const cartMessage = document.querySelector("#riviera-cart-message");
  
const generateButton =
  document.querySelector("#riviera-generate");
  const collectionButtons =
    document.querySelectorAll(".riviera-collection-button");

  const currentCollectionTitle =
    document.querySelector("#riviera-current-collection");
/* =========================================================
   APERÇU CUISINE
========================================================= */

const previewOpenButton =
  document.querySelector("#riviera-preview-open");

  const downloadCompositionButton =
  document.querySelector("#riviera-download-composition");

const previewModal =
  document.querySelector("#riviera-preview-modal");

const previewCloseButton =
  document.querySelector("#riviera-preview-close");

const previewCloseBottomButton =
  document.querySelector("#riviera-preview-close-bottom");

const previewOverlay =
  document.querySelector(".riviera-preview-modal__overlay");

const previewGrid =
  document.querySelector("#riviera-preview-grid");

const previewDimensions =
  document.querySelector("#riviera-preview-dimensions");

  if (
    !widthSelect ||
    !heightSelect ||
    !createButton ||
    !grid ||
    !productList
  ) {
    console.error("Riviera Configurator : élément HTML manquant.");
    return;
  }


  /* =========================================================
     ETAT
  ========================================================= */

  let composition = [];
  let selectedCell = 0;
  let products = [];

  let currentCollectionHandle = "esprit-mer";


  /* =========================================================
     PRIX
  ========================================================= */

  function money(cents) {
    return new Intl.NumberFormat("fr-FR", {
      style: "currency",
      currency: "EUR"
    }).format(cents / 100);
  }


  /* =========================================================
     GRILLE
  ========================================================= */

  function createGrid() {

    const width = Number(widthSelect.value);
    const height = Number(heightSelect.value);

    const total = width * height;

    composition = new Array(total).fill(null);
    selectedCell = 0;

    grid.style.gridTemplateColumns =
      `repeat(${width}, minmax(65px, 1fr))`;

    if (dimensionsText) {
      dimensionsText.textContent =
        `${width * 15} × ${height * 15} cm`;
    }

    if (countText) {
      countText.textContent =
        `${total} carreaux`;
    }

    renderGrid();
    updateComposition();
  }


  function renderGrid() {

    grid.innerHTML = "";

    composition.forEach(function (product, index) {

      const cell = document.createElement("button");

      cell.type = "button";
      cell.className = "riviera-configurator__cell";

      if (index === selectedCell) {
        cell.classList.add("is-selected");
      }

      cell.addEventListener("click", function () {
        selectedCell = index;
        renderGrid();
      });


      if (product) {

        cell.innerHTML = `
          <img
            src="${product.image}"
            alt="${escapeHtml(product.title)}"
            loading="lazy"
          >

          <span class="riviera-cell-number">
            ${index + 1}
          </span>
        `;

      } else {

        cell.innerHTML = `
          <span class="riviera-cell-number">
            ${index + 1}
          </span>

          <span class="riviera-plus">
            +
          </span>
        `;
      }

      grid.appendChild(cell);
    });
  }


  /* =========================================================
     SECURITE TEXTE
  ========================================================= */

  function escapeHtml(text) {

    const div = document.createElement("div");

    div.textContent = text || "";

    return div.innerHTML;
  }


  /* =========================================================
     COLLECTIONS SHOPIFY
  ========================================================= */

  async function loadProducts(collectionHandle) {

    currentCollectionHandle =
      collectionHandle || "esprit-mer";

    productList.innerHTML = "";

    if (productStatus) {
      productStatus.textContent =
        "Chargement...";
    }

    if (searchInput) {
      searchInput.value = "";
    }


    try {

      const response = await fetch(
        `/collections/${currentCollectionHandle}/products.json?limit=250`
      );

      if (!response.ok) {
        throw new Error("Impossible de charger la collection.");
      }

      const data = await response.json();


products = data.products
  .filter(function (product) {
    return (
      product.variants &&
      product.variants.length > 0
    );
  })
  .reduce(function (result, product) {



    /*
      PRODUIT CARREAU DE LIAISON :
      chaque variante devient un choix indépendant
    */
    if (isLinkTile) {

      product.variants.forEach(function (variant) {

        let variantImage = "";

        /*
          1. Cherche d'abord une image directement
          associée à la variante
        */
        if (
          variant.featured_image &&
          variant.featured_image.src
        ) {
          variantImage =
            variant.featured_image.src;
        }

        /*
          2. Sinon cherche dans les images du produit
          une image liée à l'ID de variante
        */
        if (
          !variantImage &&
          product.images &&
          product.images.length
        ) {

          const matchingImage =
            product.images.find(function (image) {

              return (
                image.variant_ids &&
                image.variant_ids.map(Number)
                  .includes(Number(variant.id))
              );

            });

          if (matchingImage) {
            variantImage =
              matchingImage.src;
          }
        }

        /*
          3. Dernier secours :
          première image du produit
        */
        if (
          !variantImage &&
          product.images &&
          product.images.length
        ) {
          variantImage =
            product.images[0].src;
        }

        result.push({

          id:
            product.id,

          title:
            variant.title === "Default Title"
              ? product.title
              : variant.title,

          image:
            variantImage,

          previewImage:
            variantImage,

          price:
            Math.round(
              Number(variant.price) * 100
            ),

          variantId:
            Number(variant.id),

          handle:
            product.handle
        });

      });

      return result;
    }


    /*
      TOUS LES AUTRES PRODUITS :
      fonctionnement actuel conservé
    */

    const variant =
      product.variants[0];

    const defaultImage =
      product.images &&
      product.images.length > 1
        ? product.images[1].src
        : (
            product.images &&
            product.images.length
              ? product.images[0].src
              : ""
          );

    result.push({

      id:
        product.id,

      title:
        product.title,

      image:
        defaultImage,

      previewImage:
        defaultImage,

      price:
        Math.round(
          Number(variant.price) * 100
        ),

      variantId:
        Number(variant.id),

      handle:
        product.handle
    });

    return result;

  }, []);


      renderProducts();

    } catch (error) {

      console.error(
        "Riviera Tiles :",
        error
      );

      products = [];

      if (productStatus) {
        productStatus.textContent =
          "Erreur de chargement";
      }

      productList.innerHTML = `
        <p class="riviera-no-results">
          Impossible de charger cette collection.
        </p>
      `;
    }
  }


  /* =========================================================
     PRODUITS
  ========================================================= */

  function getUsedCount(product) {

    return composition.filter(function (item) {

      return (
        item &&
        item.variantId === product.variantId
      );

    }).length;
  }


  function renderProducts() {

    productList.innerHTML = "";

    const searchValue =
      searchInput
        ? searchInput.value
            .trim()
            .toLowerCase()
        : "";


    const filteredProducts =
      products.filter(function (product) {

        if (!searchValue) {
          return true;
        }

        return product.title
          .toLowerCase()
          .includes(searchValue);
      });


    if (productStatus) {

      if (searchValue) {

        productStatus.textContent =
          `${filteredProducts.length} résultat${
            filteredProducts.length > 1 ? "s" : ""
          }`;

      } else {

        productStatus.textContent =
          `${products.length} modèles disponibles`;
      }
    }


    if (!filteredProducts.length) {

      productList.innerHTML = `
        <p class="riviera-no-results">
          Aucun carreau ne correspond à votre recherche.
        </p>
      `;

      return;
    }

if (
  currentCollectionHandle === "esprit-mer" &&
  !searchValue
) {
  filteredProducts.sort(function (a, b) {

const aLink =
  a.handle &&
  a.handle.includes("carreau-de-liaison");

const bLink =
  b.handle &&
  b.handle.includes("carreau-de-liaison");

    if (aLink && !bLink) return -1;
    if (!aLink && bLink) return 1;

    return 0;
  });
}
    filteredProducts.forEach(function (product) {

      const usedCount =
        getUsedCount(product);
const isLinkTile =
  currentCollectionHandle === "esprit-mer" &&
  product.handle &&
  product.handle.includes("carreau-de-liaison");
      const card =
        document.createElement("button");

      card.type = "button";
      card.className = "riviera-product-card";


      card.innerHTML = `
        <div class="riviera-product-card__image">
${
  isLinkTile
    ? `
      <span class="riviera-link-badge">
        ★ Carreau de liaison
      </span>
    `
    : ""
}
          ${
            usedCount > 0
              ? `
                <span class="riviera-used-badge">
                  ×${usedCount}
                </span>
              `
              : ""
          }

          ${
            product.image
              ? `
                <img
                  src="${product.image}"
                  alt="${escapeHtml(product.title)}"
                  loading="lazy"
                >
              `
              : `
                <div class="riviera-product-card__empty">
                  Image indisponible
                </div>
              `
          }

        </div>

        <div class="riviera-product-card__info">

          <strong>
            ${escapeHtml(product.title)}
          </strong>

          <span>
            ${money(product.price)}
          </span>

        </div>
      `;


      card.addEventListener("click", function () {
        placeProduct(product);
      });


      productList.appendChild(card);
    });
  }


  /* =========================================================
     PLACEMENT
  ========================================================= */

  function placeProduct(product) {

    if (
      selectedCell < 0 ||
      selectedCell >= composition.length
    ) {
      return;
    }


    composition[selectedCell] =
      product;


    /*
      Cherche automatiquement
      la prochaine case vide.
    */

    let nextEmpty =
      composition.findIndex(function (item, index) {

        return (
          item === null &&
          index > selectedCell
        );
      });


    if (nextEmpty === -1) {

      nextEmpty =
        composition.findIndex(function (item) {
          return item === null;
        });
    }


    if (nextEmpty !== -1) {
      selectedCell = nextEmpty;
    }


    renderGrid();
    updateComposition();
  }


  /* =========================================================
     MISE A JOUR GENERALE
  ========================================================= */

  function updateComposition() {

    const filled =
      composition.filter(Boolean).length;

    const missing =
      composition.length - filled;


    const totalPrice =
      composition.reduce(function (total, product) {

        return (
          total +
          (product ? product.price : 0)
        );

      }, 0);


    if (priceText) {
      priceText.textContent =
        money(totalPrice);
    }


    if (filledText) {
      filledText.textContent =
        `${filled} / ${composition.length} choisis`;
    }

/* =========================================================
   APERÇU CUISINE
========================================================= */
/* =========================================================
   TÉLÉCHARGEMENT DE LA COMPOSITION
========================================================= */

async function downloadComposition() {

  if (!composition.length) {
    return;
  }

  const filled = composition.filter(Boolean).length;

  if (!filled) {
    alert("Ajoutez au moins un carreau avant de télécharger votre composition.");
    return;
  }

  const width = Number(widthSelect.value);
  const height = Number(heightSelect.value);

  // 600 px par carreau = image HD
  const tileSize = 600;

  // Joint fin
  const joint = 8;

  const canvas = document.createElement("canvas");

  canvas.width =
    width * tileSize + (width - 1) * joint;

  canvas.height =
    height * tileSize + (height - 1) * joint;

  const ctx = canvas.getContext("2d");

  // Couleur des joints
  ctx.fillStyle = "#e7ddcc";
  ctx.fillRect(
    0,
    0,
    canvas.width,
    canvas.height
  );


  async function loadImage(url) {

    const response = await fetch(url);

    if (!response.ok) {
      throw new Error("Impossible de charger une image.");
    }

    const blob = await response.blob();

    return await createImageBitmap(blob);
  }


  try {

    for (
      let index = 0;
      index < composition.length;
      index++
    ) {

      const product = composition[index];

      if (!product || !product.image) {
        continue;
      }

      const column = index % width;
      const row = Math.floor(index / width);

      const x =
        column * (tileSize + joint);

      const y =
        row * (tileSize + joint);

      const image =
        await loadImage(product.image);

      ctx.drawImage(
        image,
        x,
        y,
        tileSize,
        tileSize
      );

      image.close();
    }


    canvas.toBlob(
      function(blob) {

        if (!blob) {
          return;
        }

        const url =
          URL.createObjectURL(blob);

        const link =
          document.createElement("a");

        link.href = url;

        link.download =
          `riviera-tiles-${width}x${height}.png`;

        document.body.appendChild(link);

        link.click();

        link.remove();

        URL.revokeObjectURL(url);

      },
      "image/png",
      1
    );


  } catch(error) {

    console.error(
      "Riviera Tiles - téléchargement :",
      error
    );

    alert(
      "Impossible de générer l'image. Veuillez réessayer."
    );
  }
}
if (
  downloadCompositionButton &&
  !downloadCompositionButton.dataset.downloadReady
) {

  downloadCompositionButton.dataset.downloadReady = "true";

  downloadCompositionButton.addEventListener(
    "click",
    downloadComposition
  );

}
function renderPreview() {

  if (!previewGrid) return;

  const width = Number(widthSelect.value);
  const height = Number(heightSelect.value);

  previewGrid.innerHTML = "";

  previewGrid.style.gridTemplateColumns =
    `repeat(${width}, 1fr)`;

  previewGrid.style.gridTemplateRows =
    `repeat(${height}, 1fr)`;

  previewGrid.style.aspectRatio =
    `${width}/${height}`;

  composition.forEach(function(product){

    const tile = document.createElement("div");

    tile.className = "riviera-preview-tile";

    if(product){

      const img = document.createElement("img");

img.src = product.previewImage || product.image;      img.alt = product.title;

      tile.appendChild(img);

    }else{

      tile.classList.add("is-empty");

    }

    previewGrid.appendChild(tile);

  });

  if(previewDimensions){

    previewDimensions.textContent =
      `${width*15} × ${height*15} cm`;

  }

}

function openPreview(){

  renderPreview();

  previewModal.classList.add("is-open");

  document.body.style.overflow="hidden";

}

function closePreview(){

  previewModal.classList.remove("is-open");

  document.body.style.overflow="";

}

if(previewOpenButton){

  previewOpenButton.addEventListener(
    "click",
    openPreview
  );

}

if(previewCloseButton){

  previewCloseButton.addEventListener(
    "click",
    closePreview
  );

}

if(previewCloseBottomButton){

  previewCloseBottomButton.addEventListener(
    "click",
    closePreview
  );

}

if(previewOverlay){

  previewOverlay.addEventListener(
    "click",
    closePreview
  );

}

document.addEventListener("keydown",function(e){

  if(
    e.key==="Escape" &&
    previewModal.classList.contains("is-open")
  ){

    closePreview();

  }

});
    /*
      PANIER
    */

    if (addCartButton) {

      addCartButton.disabled =
        composition.length === 0 ||
        missing > 0;
    }


    if (cartMessage) {

      cartMessage.classList.remove(
        "is-success",
        "is-error"
      );


      if (missing > 1) {

        cartMessage.textContent =
          `${missing} cases restent à remplir.`;

      } else if (missing === 1) {

        cartMessage.textContent =
          "Plus qu'un carreau à choisir.";

      } else if (
        composition.length > 0
      ) {

        cartMessage.textContent =
          "✓ Votre composition est prête.";

      } else {

        cartMessage.textContent =
          "Créez votre composition pour continuer.";
      }
    }


    /*
      BADGES
    */

    renderProducts();
  }


  /* =========================================================
     EFFACER UNE CASE
  ========================================================= */

  if (clearCellButton) {

    clearCellButton.addEventListener(
      "click",
      function () {

        if (
          selectedCell < 0 ||
          selectedCell >= composition.length
        ) {
          return;
        }


        composition[selectedCell] =
          null;


        renderGrid();
        updateComposition();
      }
    );
  }


  /* =========================================================
     VIDER TOUT
  ========================================================= */

  if (clearAllButton) {

    clearAllButton.addEventListener(
      "click",
      function () {

        const hasComposition =
          composition.some(Boolean);


        if (!hasComposition) {
          return;
        }


        const confirmation =
          window.confirm(
            "Voulez-vous vraiment vider toute la composition ?"
          );


        if (!confirmation) {
          return;
        }


        composition =
          new Array(
            composition.length
          ).fill(null);

        selectedCell = 0;


        renderGrid();
        updateComposition();
      }
    );
  }


  /* =========================================================
     CHANGEMENT DE COLLECTION
  ========================================================= */

  collectionButtons.forEach(function (button) {

    button.addEventListener(
      "click",
      function () {

        const newHandle =
          button.dataset.handle;

        const newName =
          button.dataset.name;


        if (
          !newHandle ||
          newHandle === currentCollectionHandle
        ) {
          return;
        }


        const hasComposition =
          composition.some(Boolean);


        if (hasComposition) {

          const confirmation =
            window.confirm(
              "Changer de collection effacera votre composition actuelle. Continuer ?"
            );


          if (!confirmation) {
            return;
          }


          composition =
            new Array(
              composition.length
            ).fill(null);

          selectedCell = 0;

          renderGrid();
          updateComposition();
        }


        collectionButtons.forEach(
          function (item) {

            item.classList.remove(
              "is-active"
            );
          }
        );


        button.classList.add(
          "is-active"
        );


        if (currentCollectionTitle) {

          currentCollectionTitle.textContent =
            newName;
        }


        loadProducts(
          newHandle
        );
      }
    );
  });


  /* =========================================================
     DIMENSIONS
  ========================================================= */

  createButton.addEventListener(
    "click",
    function () {

      const hasComposition =
        composition.some(Boolean);


      if (hasComposition) {

        const confirmation =
          window.confirm(
            "Modifier les dimensions effacera votre composition actuelle. Continuer ?"
          );


        if (!confirmation) {
          return;
        }
      }


      createGrid();
    }
  );


  /* =========================================================
     RECHERCHE
  ========================================================= */

  if (searchInput) {

    searchInput.addEventListener(
      "input",
      renderProducts
    );
  }

/* -------------------------------------------------------
   GENERATION AUTOMATIQUE D'UNE COMPOSITION
------------------------------------------------------- */

function generateComposition() {

  if (!products.length) {
    return;
  }

  const maxPerProduct =
    Math.max(
      2,
      Math.ceil(composition.length / 6)
    );

  const usage = {};
  const generated = [];

  for (let i = 0; i < composition.length; i++) {

    let candidates = products.filter(function(product){

      const count =
        usage[product.variantId] || 0;

      return count < maxPerProduct;

    });

    if (!candidates.length) {
      candidates = products.slice();
    }

    if (i > 0) {

      const previous =
        generated[i - 1];

      const withoutPrevious =
        candidates.filter(function(product){

          return (
            !previous ||
            product.variantId !== previous.variantId
          );

        });

      if (withoutPrevious.length) {
        candidates = withoutPrevious;
      }

    }

    const product =
      candidates[
        Math.floor(
          Math.random() *
          candidates.length
        )
      ];

    generated.push(product);

    usage[product.variantId] =
      (usage[product.variantId] || 0) + 1;

  }

  composition = generated;

  selectedCell = 0;

  renderGrid();

  updateComposition();

}
if (generateButton) {

  generateButton.addEventListener(
    "click",
    function () {

      const hasComposition =
        composition.some(Boolean);

      if (hasComposition) {

        const confirmation =
          window.confirm(
            "Créer une nouvelle proposition remplacera votre composition actuelle. Continuer ?"
          );

        if (!confirmation) {
          return;
        }

      }

      generateComposition();

    }
  );

}
  /* =========================================================
     PANIER SHOPIFY
  ========================================================= */

  async function addCompositionToCart() {

    if (
      !addCartButton ||
      !composition.length
    ) {
      return;
    }


    const missing =
      composition.filter(function (item) {
        return !item;
      }).length;


    if (missing > 0) {

      if (cartMessage) {

        cartMessage.textContent =
          `${missing} case${
            missing > 1 ? "s" : ""
          } reste${
            missing > 1 ? "nt" : ""
          } à remplir.`;

        cartMessage.classList.add(
          "is-error"
        );
      }

      return;
    }


    /*
      REGROUPE LES PRODUITS IDENTIQUES
    */

    const quantities = {};


    composition.forEach(function (product) {

      const id =
        String(product.variantId);


      if (!quantities[id]) {

        quantities[id] = {
          id: Number(product.variantId),
          quantity: 0
        };
      }


      quantities[id].quantity += 1;
    });


    const width =
      Number(widthSelect.value);

    const height =
      Number(heightSelect.value);


    const collectionName =
      currentCollectionTitle
        ? currentCollectionTitle
            .textContent
            .trim()
        : "Riviera Tiles";


    const items =
      Object.values(quantities).map(
        function (item) {

          return {

            id:
              item.id,

            quantity:
              item.quantity,

            properties: {

              "Projet":
                "Composition personnalisée Riviera Tiles",

              "Collection":
                collectionName,

              "Format":
                `${width} × ${height} carreaux`,

              "Dimensions":
                `${width * 15} × ${height * 15} cm`
            }
          };
        }
      );


    try {

      addCartButton.disabled =
        true;

      addCartButton.classList.add(
        "is-loading"
      );

      addCartButton.textContent =
        "Ajout au panier...";


      if (cartMessage) {

        cartMessage.textContent =
          "Préparation de votre panier...";
      }


      const response =
        await fetch(
          "/cart/add.js",
          {
            method: "POST",

            headers: {
              "Content-Type":
                "application/json",

              "Accept":
                "application/json"
            },

            body: JSON.stringify({
              items: items
            })
          }
        );


      if (!response.ok) {

        let message =
          "Impossible d'ajouter la composition au panier.";

        try {

          const errorData =
            await response.json();

          if (errorData.description) {
            message =
              errorData.description;
          }

        } catch (e) {
          // Rien à faire.
        }


        throw new Error(message);
      }


      if (cartMessage) {

        cartMessage.textContent =
          "✓ Composition ajoutée au panier.";

        cartMessage.classList.add(
          "is-success"
        );
      }


      /*
        Pour le moment :
        redirection vers le panier.
      */

      window.location.href =
        "/cart";


    } catch (error) {

      console.error(
        "Riviera Tiles - erreur panier :",
        error
      );


      addCartButton.disabled =
        false;


      addCartButton.textContent =
        "Ajouter cette composition au panier";


      if (cartMessage) {

        cartMessage.textContent =
          error.message;

        cartMessage.classList.add(
          "is-error"
        );
      }
    }
  }


  if (addCartButton) {

    addCartButton.addEventListener(
      "click",
      addCompositionToCart
    );
  }


  /* =========================================================
     INITIALISATION
  ========================================================= */

  createGrid();

  loadProducts(
    "esprit-mer"
  );

});